import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d3d55ba"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6d3d55ba&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d3d55ba')) {
      api.createRecord('6d3d55ba', component.options)
    } else {
      api.reload('6d3d55ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6d3d55ba", function () {
      api.rerender('6d3d55ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/file/edit/index.vue"
export default component.exports